import moment from 'moment';
import appConfig from '../config';

export const trimTextAddingEllipsis = (text, size) => {
  if (!text) {
    return;
  }
  if (text.length <= size) {
    return text;
  }
  const subString = text.substr(0, size - 1);
  return `${subString.substr(0, subString.lastIndexOf(' ')).replace(/\.,*$/, '')} …`;
};

export const getDisabledMealAvailableDays = mealDisabledDays => {
  const mealAvailableDays = [];
  [1, 2, 3, 4, 5, 6, 7].forEach(day => !mealDisabledDays.includes(day) && mealAvailableDays.push(moment().isoWeekday(day).format('dddd')));
  return mealAvailableDays.join(', ').replace(/,\s([^,]+)$/, ' and $1');
};

export const sanitizeUrl = url => `//${url.replace(/http:\/\/|https:\/\/\b/g, '')}`;

export const getBackgroundImage = url => {
  if (url) {
    return {
      desktop: `${url}=s1600`,
      tablet: `${url}=s1024`,
      mobile: `${url}=s640`
    };
  }
  return {
    desktop: `${appConfig.defaultCdnUrl}bbq-burgers-bg.jpg`,
    tablet: `${appConfig.defaultCdnUrl}bbq-burgers-bg-tablet.jpg`,
    mobile: `${appConfig.defaultCdnUrl}bbq-burgers-bg-mobile.jpg`
  };
};



// WEBPACK FOOTER //
// ./helpers/string.helper.js